import React from 'react';
import { motion } from 'framer-motion';
import { TagIcon, ZapIcon } from 'lucide-react';
const promos = [{
  name: 'Senegalese Twist Full Bob',
  price: '$200',
  image: 'https://cdn.magicpatterns.com/uploads/bs5n9Zm32XefA6AMuJFbwS/WhatsApp_Image_2026-03-27_at_7.53.20_PM_(1).jpg'
}, {
  name: 'Stitch Braids',
  price: '$200',
  image: 'https://cdn.magicpatterns.com/uploads/bmJUp6HFtTtQiY35uSMDU6/WhatsApp_Image_2026-03-27_at_7.57.48_PM.jpg'
}, {
  name: 'Full Long Bob Special',
  price: '$200',
  image: 'https://cdn.magicpatterns.com/uploads/6ZTKdhPAjvsbMBap6AKGnP/WhatsApp_Image_2026-03-27_at_7.53.20_PM.jpg'
}, {
  name: 'Medium Mid-Back',
  price: '$140',
  image: 'https://cdn.magicpatterns.com/uploads/xw8DuN4qsKH2eRTToQZS5E/WhatsApp_Image_2026-03-27_at_7.53.57_PM.jpg'
}, {
  name: 'Waist Length',
  price: '$160',
  image: 'https://cdn.magicpatterns.com/uploads/nSTHv4x5S1XDhv6UarqhMU/WhatsApp_Image_2026-03-27_at_7.53.45_PM.jpg'
}];
export function PromoOffers({
  showTitle = true
}: {
  showTitle?: boolean;
}) {
  return <section className="py-12 bg-brand-gold/5 border-y border-brand-gold/20" data-id="element-296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        {showTitle && <div className="flex items-center justify-center gap-3 mb-10" data-id="element-298">
            <ZapIcon className="w-6 h-6 text-brand-gold fill-brand-gold" data-id="element-299" />
            <h2 className="font-display text-3xl md:text-4xl text-near-black text-center" data-id="element-300">
              Current Specials & Promos
            </h2>
            <ZapIcon className="w-6 h-6 text-brand-gold fill-brand-gold" data-id="element-301" />
          </div>}

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6" data-id="element-302">
          {promos.map((promo, index) => <motion.a href="tel:2409217857" key={promo.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream rounded-xl md:rounded-2xl border-2 border-brand-gold/30 flex flex-col items-center text-center group hover:border-brand-gold transition-all shadow-sm overflow-hidden block" data-id="element-303">
              <div className="w-full aspect-square overflow-hidden" data-id="element-304">
                <img src={promo.image} alt={promo.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-305" />
              </div>
              <div className="p-2 md:p-4 flex flex-col justify-center flex-grow" data-id="element-306">
                <h3 className="font-body font-bold text-[8px] md:text-[10px] uppercase tracking-wider text-near-black mb-1 line-clamp-2" data-id="element-307">
                  {promo.name}
                </h3>
                <span className="font-display text-lg md:text-2xl text-brand-gold group-hover:scale-110 transition-transform inline-block" data-id="element-308">
                  {promo.price}
                </span>
              </div>
            </motion.a>)}
        </div>

        <div className="mt-10 text-center" data-id="element-309">
          <p className="font-body text-near-black/60 text-sm italic" data-id="element-310">
            *Offers subject to change. Mention these promos when booking!
          </p>
        </div>
      </div>
    </section>;
}